"use strict";
import _ from 'lodash';

export default class EventEditController
{
	/*@ngInject*/
	constructor($http, $scope, $stateParams, $state, $log, ValidationService, messageService)
	{
		//console.log("EventEditController");
		if (_.isNil($stateParams.id))
			return $state.go("myevents");

		this.$http = $http;
		this.$state = $state;
		this.$log = $log;
		this.validation = new ValidationService();
		this.messageService = messageService;
		this.eventId = $stateParams.id;

		if (!$stateParams.id) return $state.go("home");
		this.eventId = $stateParams.id;
		this.data = {};

		this.viewPromise = $http.post("/api/backend/events/" + this.eventId)
		.then(response =>
		{
			//for (var attrname in response.data) {
			//	this.data[attrname] = response.data[attrname];
			//}
			this.data = response.data;

			if (this.data.form2mail !== null)
				this.data.form2mail = JSON.stringify(this.data.form2mail, '\n', 4);

			let selectedClub = this.data.selectedclub;
			let selectedTrack = this.data.selectedtrack;

			this.data.selectedclub = _.find(this.data.clubs, function(c) { return c.id === selectedClub; });
			this.data.selectedtrack = _.find(this.data.tracks, function(t) { return t.id === selectedTrack; });

			this.data.fromdate = new Date(this.data.fromdate);
			this.data.fromdateHours = new Date(this.data.fromdate);

			this.data.todate = new Date(this.data.todate);
			this.data.todateHours = new Date(this.data.todate);

			this.data.openinscriptions = new Date(this.data.openinscriptions);
			this.data.openinscriptionsHours = new Date(this.data.openinscriptions);
			
			this.data.closeinscriptions = new Date(this.data.closeinscriptions);
			this.data.closeinscriptionsHours = new Date(this.data.closeinscriptions);

			// Transform races adding category
			for (let i = 0; i < this.data.races.length; ++i)
			{
				let r = this.data.races[i];
				let idx = _.findIndex(this.data.categories, function(c) { return c.id === r.category_id; });
				if (idx != -1)
				{
					r.category = this.data.categories[idx];
					r.category_id = undefined;
				}
			}
		});
	}

	Modify(form)
	{
		this.showError = false;

		if (!this.validation.checkFormValidity(form)) 
		{
			this.showError = true;
			return;
		}

		let ret = this.CollectEventData(this.data);
		if (ret == null) return;

		this.$http.post("/api/backend/events/update/" + this.eventId, ret)
		.then(response =>
		{
			this.messageService.Success("Datos guardados");
			this.$state.go("myevents");
		})
		.catch(err =>
		{
			this.$log.warn(err);
			this.messageService.Error(err.data);
		});
	}
		
	Delete()
	{
		this.$http.post("/api/backend/events/delete/" + this.eventId)
		.then(response =>
		{
			this.$state.go("myevents");
		});
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/events/event_edit.controller.js